<template>
  <tr class="procedimento"
    v-bind:class="{
      'procedimentos-table-new-procedimento': procedimento._isNew,
      'procedimentos-table-error-procedimento': procedimento._isError
    }">
    <td :width="sizes.fatorCustoOperacional">
      <input type="text"
      v-model="procedimento.fatorCustoOperacional"
      v-on:input="clearApplyToAll('fatorCustoOperacional')" />
    </td>
    <td :width="sizes.fator">
      <input type="text"
      v-model="procedimento.fator"
      v-on:input="clearApplyToAll('fator')" />
    </td>
    <td :width="sizes.valorProcedimento">
      <input type="text"
      v-model="procedimento.valorProcedimento"
      v-on:input="clearApplyToAll('valorProcedimento')" />
    </td>
    <td :width="sizes.valorTabela">
      <span v-if="!procedimento.valorProcedimento">
        R$ {{ procedimento.valorTabela }}
      </span>
    </td>
    <td :width="sizes.tipoPrazo">
      <select v-model="procedimento.tipoPrazo">
        <option value="1">Dias corridos</option>
        <option value="2">Competencia</option>
      </select>
    </td>
    <td :width="sizes.quantidadedMesPrazoCompetencia">
      <input type="text"
      v-model="procedimento.prazoRecebimento"
      v-on:input="clearApplyToAll('prazoRecebimento')" />
    </td>
    <td :width="sizes.mesesSubsequentes">
      <input type="text"
      v-if="procedimento.tipoPrazo == 2"
      v-model="procedimento.quantidadedMesPrazoCompetencia"
      v-on:input="clearApplyToAll('quantidadedMesPrazoCompetencia')" />
    </td>
    <td :width="sizes.fatorUrgencia">
      <input type="text"
      v-model="procedimento.fatorUrgencia"
      v-on:input="clearApplyToAll('fatorUrgencia')" />
    </td>
    <td :width="sizes.fatorAcomodacao">
      <input type="text"
      v-model="procedimento.fatorAcomodacao"
      v-on:input="clearApplyToAll('fatorAcomodacao')" />
    </td>
    <td :width="sizes.fatorViaUnica" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorViaUnica"
      v-on:input="clearApplyToAll('fatorViaUnica')" />
    </td>
    <td :width="sizes.fatorViaSeparada" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorViaSeparada"
      v-on:input="clearApplyToAll('fatorViaSeparada')" />
    </td>
    <td :width="sizes.fatorCirurgiao" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorCirurgiao"
      v-on:input="clearApplyToAll('fatorCirurgiao')" />
    </td>
    <td :width="sizes.fatorAuxiliar1" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorAuxiliar1"
      v-on:input="clearApplyToAll('fatorAuxiliar1')" />
    </td>
    <td :width="sizes.fatorAuxiliar2" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorAuxiliar2"
      v-on:input="clearApplyToAll('fatorAuxiliar2')" />
    </td>
    <td :width="sizes.fatorAuxiliar3" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorAuxiliar3"
      v-on:input="clearApplyToAll('fatorAuxiliar3')" />
    </td>
    <td :width="sizes.fatorAuxiliar4" v-if="groups > 1">
      <input type="text"
      v-model="procedimento.fatorAuxiliar4"
      v-on:input="clearApplyToAll('fatorAuxiliar4')" />
    </td>
    <td :width="sizes.acoes" class="text-left">
      <v-btn
      @click="deleteProcedimento(procedimento)"
      fab dark small outline color="error">
        <v-icon dark>remove</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    groups: {
      type: Array,
    },
    procedimento: {
      type: Object,
      default: () => ({}),
    },
    sizes: {
      default: {},
      type: Object,
    },
    tiposPrazoRecebimento: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {}
  },
  methods: {
    clearApplyToAll(field) {
      this.$emit('clearApplyToAll', field)
    },

    clearErrorValidation() {
      this.procedimento._isError = false
      this.$emit('countBadges')
    },

    deleteProcedimento(procedimento) {
      this.$emit('deleteProcedimento', procedimento)
    },
  },
  watch: {
    'procedimento.fator': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },

    'procedimento.fatorCustoOperacional': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },

    'procedimento.prazoRecebimento': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },

    'procedimento.quantidadedMesPrazoCompetencia': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },

    'procedimento.tipoPrazo': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },

    'procedimento.valorProcedimento': function () {
      if (this.procedimento._isError) this.clearErrorValidation()
    },
  },
}
</script>

<style lang="scss" scoped>
.procedimento {
  td {
    padding: 5px 10px;
    vertical-align: middle;
    font-size: 13px;
    min-height: 30px;
    height: 50px;
    border: none;
    text-align: center
  }

  tr {
    border: 1px solid #CCC;
    border-right: 0
  }

  td {
    input[type=text] {
      text-align: center;
      padding: 0 5px;
      width: 100%;
      border-bottom: 1px solid #CCC;

      &:focus {
        outline: 0;
        border-bottom: 2px solid #04a5ed;
      }
    }

    select {
      border-bottom: 1px solid #CCC;
      width: 100%;
      appearance: menulist;

      &:focus {
        outline: 0;
        border-bottom: 2px solid #04a5ed;
      }
    }
  }

  .v-btn--floating.v-btn--small {
    width: 20px;
    height: 20px;
  }
}
</style>
